<template>
  <PagesNonprofitHeadIntro :title="title" :description="description" />
  <PagesNonprofitSectionContent :contents="contents" />
</template>
<script lang="ts" setup>
import NonprofitLocale from "~~/config/widgets/for-nonprofit";

const nonprofit = new NonprofitLocale();
const title = nonprofit.title;
const description = nonprofit.description;
const contents = nonprofit.content;

import moment from "moment";
import DataLocale from "~~/config/interface/DataLocale";

const seoheader = new DataLocale([
  {
    locale: "en",
    title: "Boosting Non-Profit Organizations with QR Codes",
    description:
      "Using QR Codes in the marketing strategy of non-profit organizations is an effective way to enhance brand awareness and fundraising. Moreover, QR Codes can also be used to introduce programs, share important information, and connect with the community.",
    keywords:
      "nonprofit qrcode,qrcode fundraising,charity qrcode,qrcode donations,nonprofit marketing with qrcode,qrcode for social impact,qrcode philanthropy,nonprofit branding with qrcode",
  },
  {
    locale: "fr",
    title: "Booster les organisations à but non lucratif avec des codes QR",
    description:
      "L'utilisation des codes QR dans la stratégie marketing des organisations à but non lucratif est un moyen efficace d'améliorer la notoriété de la marque et la collecte de fonds. De plus, les codes QR peuvent également être utilisés pour présenter des programmes, partager des informations importantes et se connecter avec la communauté.",
    keywords:
      "qrcode organisation à but non lucratif, qrcode collecte de fonds, qrcode pour les œuvres de bienfaisance, dons avec qrcode, marketing des organisations à but non lucratif avec qrcode, qrcode pour l'impact social, philanthropie avec qrcode, branding des organisations à but non lucratif avec qrcode",
  },

  {
    locale: "de",
    title: "Non-Profit-Organisationen mit QR-Codes aufwerten",
    description:
      "Die Verwendung von QR-Codes in der Marketingstrategie von Non-Profit-Organisationen ist eine effektive Möglichkeit, die Markenbekanntheit und Fundraising zu verbessern. Darüber hinaus können QR-Codes auch verwendet werden, um Programme vorzustellen, wichtige Informationen zu teilen und sich mit der Gemeinschaft zu verbinden.",
    keywords:
      "Nonprofit-QR-Code, QR-Code-Fundraising, Charity-QR-Code, QR-Code-Spenden, Nonprofit-Marketing mit QR-Code, QR-Code für sozialen Einfluss, Philanthropie mit QR-Code, Nonprofit-Branding mit QR-Code",
  },

  {
    locale: "it",
    title: "Potenziare le Organizzazioni non Profit con i Codici QR",
    description:
      "L'uso dei Codici QR nella strategia di marketing delle organizzazioni non profit è un modo efficace per migliorare la consapevolezza del marchio e la raccolta fondi. Inoltre, i Codici QR possono essere utilizzati anche per presentare programmi, condividere informazioni importanti e connettersi con la comunità.",
    keywords:
      "codice qr organizzazione non profit, raccolta fondi con codice qr, codice qr per beneficienza, donazioni con codice qr, marketing delle organizzazioni non profit con codice qr, codice qr per l'impatto sociale, filantropia con codice qr, branding delle organizzazioni non profit con codice qr",
  },

  {
    locale: "pt",
    title: "Impulsionando Organizações sem Fins Lucrativos com Códigos QR",
    description:
      "Usar códigos QR na estratégia de marketing de organizações sem fins lucrativos é uma maneira eficaz de aumentar a conscientização da marca e a arrecadação de fundos. Além disso, os códigos QR também podem ser usados para apresentar programas, compartilhar informações importantes e se conectar com a comunidade.",
    keywords:
      "qrcode organização sem fins lucrativos, qrcode arrecadação de fundos, qrcode para caridade, doações com qrcode, marketing de organizações sem fins lucrativos com qrcode, qrcode para impacto social, filantropia com qrcode, branding de organizações sem fins lucrativos com qrcode",
  },
  {
    locale: "es",
    title: "Impulsando Organizaciones sin Ánimo de Lucro con Códigos QR",
    description:
      "El uso de códigos QR en la estrategia de marketing de organizaciones sin ánimo de lucro es una forma efectiva de mejorar el conocimiento de la marca y la recaudación de fondos. Además, los códigos QR también se pueden utilizar para presentar programas, compartir información importante y conectarse con la comunidad.",
    keywords:
      "códigos QR sin ánimo de lucro, códigos QR para recaudar fondos, códigos QR para caridad, donaciones con códigos QR, marketing sin ánimo de lucro con códigos QR, códigos QR para impacto social, filantropía con códigos QR, branding sin ánimo de lucro con códigos QR",
  },
  {
    locale: "nl",
    title: "Non-Profit Organisaties versterken met QR-codes",
    description:
      "Het gebruik van QR-codes in de marketingstrategie van non-profitorganisaties is een effectieve manier om de merkbekendheid en fondsenwerving te verbeteren. Bovendien kunnen QR-codes ook worden gebruikt om programma's te introduceren, belangrijke informatie te delen en contact te maken met de gemeenschap.",
    keywords:
      "non-profit qr-code, qr-code voor fondsenwerving, qr-code voor liefdadigheid, qr-code donaties, non-profit marketing met qr-code, qr-code voor maatschappelijke impact, filantropie met qr-code, branding zonder winstoogmerk met qr-code",
  },
  {
    locale: "vi",
    title:
      "Sử dụng mã QR để tăng cường hoạt động của các tổ chức phi lợi nhuận",
    description:
      "Sử dụng mã QR trong chiến lược marketing của tổ chức phi lợi nhuận là một cách hiệu quả để tăng cường nhận thức thương hiệu và gây quỹ. Ngoài ra, mã QR cũng có thể được sử dụng để giới thiệu chương trình hoạt động, chia sẻ thông tin quan trọng và kết nối với cộng đồng.",
    keywords:
      "mã QR cho tổ chức phi lợi nhuận, mã QR gây quỹ, từ thiện với mã QR, quảng cáo tổ chức phi lợi nhuận với mã QR, mã QR ảnh hưởng đến xã hội, mã QR cho branding tổ chức phi lợi nhuận",
  },
  {
    locale: "ja",
    title: "非営利団体の活動をQRコードで強化する",
    description:
      "非営利団体のマーケティング戦略にQRコードを活用することで、ブランド認知度の向上や資金調達の促進が効果的に行えます。また、QRコードはプログラムの紹介や重要な情報の共有、コミュニティとのつながりを構築するためにも使用することができます。",
    keywords:
      "非営利団体のQRコード、QRコードの寄付、慈善団体のQRコード、非営利団体のマーケティング、社会貢献のQRコード、非営利団体のブランディング用QRコード",
  },
  {
    locale: "zh",
    title: "使用QR码增强非营利组织的活动",
    description:
      "在非营利组织的营销策略中使用QR码是增强品牌知名度和筹集资金的有效方式。此外，QR码还可用于介绍计划、共享重要信息和与社区建立联系。",
    keywords:
      "非营利组织的QR码、QR码筹款、慈善机构的QR码、QR码营销、QR码的社会影响、非营利组织的品牌营销",
  },
]);

const datajd = useDataJd();
const meta = useMeta();

const i18nHead = useLocaleHead({
  addSeoAttributes: {
    canonicalQueries: ["/"],
  },
});
const meta_tags = meta.metaTag({
  title: seoheader.data.title,
  description: seoheader.data.description,
  url: datajd.currentURL(),
  image: datajd.assets("/images/og/nonprofit.jpg"),
});
useHead({
  title: seoheader.data.title,
  meta: [
    { name: "description", content: seoheader.data.description },
    { name: "keywords", content: seoheader.data.keywords },
    ...(i18nHead.value.meta || []),
    ...meta_tags,
  ],
  htmlAttrs: {
    lang: i18nHead.value.htmlAttrs!.lang,
  },
  link: [...(i18nHead.value.link || [])],
});
useSchemaOrg([
  defineWebPage({
    name: seoheader.data.title,
    datePublished: moment("2023-05-03").toISOString(),
    dateModified: moment().toISOString(),
    description: seoheader.data.description,
    inLanguage: datajd.inLanguages(true),
    url: datajd.currentURL(),
    image: datajd.assets("/images/og/nonprofit.jpg"),
  }),
  defineBreadcrumb({
    itemListElement: [
      {
        item: {
          "@id": datajd.currentHost(),
          name: "Home",
        },
      },
      {
        item: {
          name: "QR Codes in Nonprofit",
          "@id": datajd.currentHost() + useRoute().fullPath,
        },
      },
    ],
  }),
]);
</script>
